module.exports = {
  plus: [{
    text: 'Meget upræcist',
    score: 1,
    color: 1
  }, {
    text: 'Rimelig upræcist',
    score: 2,
    color: 2
  }, {
    text: 'Hverken præcist eller upræcist',
    score: 3,
    color: 3
  }, {
    text: 'Rimelig præcist',
    score: 4,
    color: 4
  }, {
    text: 'Meget præcist',
    score: 5,
    color: 5
  }],
  minus: [{
    text: 'Meget upræcist',
    score: 5,
    color: 1
  }, {
    text: 'Rimelig upræcist',
    score: 4,
    color: 2
  }, {
    text: 'Hverken præcist eller upræcist',
    score: 3,
    color: 3
  }, {
    text: 'Rimelig præcist',
    score: 2,
    color: 4
  }, {
    text: 'Meget præcist',
    score: 1,
    color: 5
  }]
};